var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { jsx } from "react/jsx-runtime";
import * as React from "react";
import { createContext, useContext } from "react";
const HeaderContext = createContext({});
const ContextProvider = HeaderContext.Provider;
const useHeaderContext = (selector) => selector(useContext(HeaderContext));
const HeaderProvider = (props) => {
  const { id } = props;
  const defaultState = {
    currentFeatureId: id,
    expandedProgressions: {},
    isProgressionSelectionVisible: false
  };
  const [state, setState] = React.useState(defaultState);
  const initializeValues = React.useCallback(
    (currentFeatureId) => setState((s) => __spreadProps(__spreadValues({}, s), { currentFeatureId })),
    [setState]
  );
  return /* @__PURE__ */ jsx("div", { className: "App", children: /* @__PURE__ */ jsx(
    ContextProvider,
    {
      value: __spreadProps(__spreadValues({}, state), {
        initializeValues
      }),
      children: props.children
    }
  ) });
};
export {
  ContextProvider,
  HeaderContext,
  HeaderProvider,
  HeaderProvider as default,
  useHeaderContext
};
//# sourceMappingURL=HeaderProvider.js.map
